module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"reviews_count":"レビュー %{count}件","review_description":"{percentage}が <b>{score}</b> と評価しました。"}}')
  delete Component.options._Ctor
}
